import { PAYMENT_CHANELS, PageName } from "../constants/common";
import {
  ChannelItemType,
  MethodItemType,
  OfferItemType,
  StorageKEY,
  VoucherItemType,
} from "../models";
import client from "./client";

export const checkoutApi = {
  fetchChanelAndMethod: async (args?: {
    platform?: string;
    version?: string;
  }): Promise<{
    error: number;
    data: {
      method: MethodItemType[];
      channel: ChannelItemType[];
    };
    [key: string]: any;
  }> => {
    const { version = "1.3", platform = "web" } = args || {};
    const authToken = localStorage.getItem(StorageKEY.authToken);
    let responseData: {
      data: { method: MethodItemType[]; channel: ChannelItemType[] };
      error: number;
    } = { data: { method: [], channel: [] }, error: 0 };
    try {
      const response = await client.get(
        `billing/channel/channelAndMethod?platform=${platform}&version=${version}`,
        {
          headers: {
            "access-token": authToken,
          },
        }
      );

      if (response.data.error === 0) {
        responseData = {
          data: response.data.data,
          error: response.data.error,
        };
      } else {
        responseData = {
          error: response.data.errorCode,
          data: {
            method: [],
            channel: [],
          },
          ...response.data,
        };
      }
    } catch (error) {
      console.log({ error });
    }

    return responseData;
  },
  getVoucherType: async (): Promise<{
    data: VoucherItemType[];
    error: number;
    message: string;
  }> => {
    const authToken = localStorage.getItem(StorageKEY.authToken);
    const campaignId = process.env.REACT_APP_CAMPAIGN_ID;
    let responseData = {
      data: [],
      error: 0,
      message: "",
    };
    try {
      const response = await client.post(
        `promotion/v2/landingpage/checkVoucherType`,
        {
          headers: {
            "access-token": authToken,
          },
          body: {
            campaignId: campaignId,
          },
        }
      );
      if (response.data.error === 0) {
        responseData = {
          ...response.data,
        };
      } else {
        responseData = {
          ...responseData,
          ...response.data,
        };
      }
    } catch (error) {
      console.log(error);
    }
    return responseData;
  },

  getPromotionOffer: async (options: { titleId: string, channelType: PageName | undefined }) => {
    const { titleId, channelType } = options;
    let campaignId = ''
    switch (channelType) {
      case PageName.SHOPEE: {
        campaignId = process.env.REACT_APP_CAMPAIGN_ID_SHOPEEPAY || '';
        break;
      }
      case PageName.ZALO: {
        campaignId = process.env.REACT_APP_CAMPAIGN_ID_ZALOPAY || '';
        break;
      }
      case PageName.VNPAY: {
        campaignId = process.env.REACT_APP_CAMPAIGN_ID_VNPAY || '';
        break;
      }
    }
    const authToken = localStorage.getItem(StorageKEY.authToken);

    const response = await client.post(`promotion/v2/getOffer`, {
      headers: {
        "access-token": authToken,
      },
      body: {
        eventPage: process.env.REACT_APP_EVENT_PAGE,
        campaignId: campaignId,
        titleId, //demo id: "63eafdb1b426e71358699b5e"
      },
    });
    return response.data;
  },

  syncPaymentMethod: async ({
    channelType,
    clientId,
    returnUrl,
    offer,
  }: {
    channelType: string;
    clientId: string;
    returnUrl: string;
    offer: OfferItemType;
  }) => {
    const authToken = localStorage.getItem(StorageKEY.authToken);

    let subUrlOne = "";
    let subUrlTwo = "sync";
    let bodyData = {};
    switch (channelType) {
      case PAYMENT_CHANELS.SHOPEEPAY: {
        subUrlOne = "shopee";
        bodyData = { channelType, clientId, returnUrl };
        break;
      }

      case PAYMENT_CHANELS.ZALOPAY: {
        subUrlOne = "zalo";
        bodyData = { channelType, clientId, returnUrl };
        break;
      }

      case PAYMENT_CHANELS["VNPAY-QR"]: {
        subUrlOne = "vnpay";
        subUrlTwo = "createqr";
        bodyData = { offer };
        break;
      }
    }
    const response = await client.post(`billing/${subUrlOne}/${subUrlTwo}`, {
      headers: {
        "access-token": authToken,
      },
      body: {
        ...bodyData,
      },
    });

    return response.data;
  },
  makePayment: async (args: {
    methodId: string;
    offer: OfferItemType;
    token?: string;
  }) => {
    let authToken = localStorage.getItem(StorageKEY.authToken);
    if (args.token) {
      authToken = args.token;
    }
    const { methodId, offer } = args;
    const response = await client.post(`billing/subscription/buy`, {
      headers: {
        "access-token": authToken,
      },
      body: {
        methodId,
        offer,
      },
    });

    return response.data;
  },
  vnpayRedirectURL: async ({
    offer,
    returnUrl,
  }: {
    offer: OfferItemType;
    returnUrl: string;
  }) => {
    const authToken = localStorage.getItem(StorageKEY.authToken);

    const response = await client.post(`billing/vnpay/urlRedirect`, {
      headers: {
        "access-token": authToken,
      },
      body: {
        returnUrl,
        offer,
      },
    });
    return response.data;
  },

  getAcountWalletInforShopee: async ({
    authCode,
    requestId,
    userId,
  }: {
    authCode: string;
    requestId: string;
    userId: string;
  }) => {
    const authToken = localStorage.getItem(StorageKEY.authToken);

    const response = await client.post(`billing/shopee/confirm`, {
      headers: {
        "access-token": authToken,
      },
      body: {
        authCode,
        requestId,
        userId,
      },
    });
    return response.data;
  },
};
